import React from 'react';
import { ArrowLeft, FilePlus, FileSignature, ScrollText } from '../../../../shared/assets/AppIcons';
import CreateContractForm from './CreateContractForm';
import CreateMandateForm from './CreateMandateForm';
import {
  CreateFormCancelButton,
  CreateFormDialog,
  CreateFormSubmitButton,
} from '../../../../shared/components/CreateFormDialog';

export default function CreateDocumentTypeDialog({
  open,
  onOpenChange,
  selectedDocType,
  onSelectDocType,
  onBack,
  clients,
  clientsUnavailable = false,
  mandateForm,
  contractForm,
}) {
  return (
    <CreateFormDialog
      busy={contractForm?.isSubmitting || mandateForm?.isSubmitting}
      open={open}
      onOpenChange={onOpenChange}
      icon={
        selectedDocType === 'contratto'
          ? FileSignature
          : selectedDocType === 'mandato'
            ? ScrollText
            : FilePlus
      }
      title={
        selectedDocType === 'contratto'
          ? 'Nuovo Contratto'
          : selectedDocType === 'mandato'
            ? 'Nuovo Mandato di Assistenza'
            : 'Nuovo Documento'
      }
      description={
        selectedDocType
          ? `Compila i dati per generare il ${selectedDocType === 'contratto' ? 'contratto' : 'mandato di assistenza'}`
          : 'Seleziona il tipo di documento da creare'
      }
      footer={
        <>
          <CreateFormCancelButton
            onClick={() => (selectedDocType ? onBack() : onOpenChange(false))}
            disabled={contractForm?.isSubmitting || mandateForm?.isSubmitting}
          >
            {selectedDocType ? 'Indietro' : 'Annulla'}
          </CreateFormCancelButton>
          {selectedDocType === 'contratto' ? (
            <CreateFormSubmitButton saving={contractForm?.isSubmitting} form="create-contract-form">
              Salva contratto
            </CreateFormSubmitButton>
          ) : null}
          {selectedDocType === 'mandato' ? (
            <CreateFormSubmitButton saving={mandateForm?.isSubmitting} form="create-mandate-form">
              Salva mandato
            </CreateFormSubmitButton>
          ) : null}
        </>
      }
    >
      {!selectedDocType ? (
        <div className="grid grid-cols-2 gap-4 py-6">
          <button
            type="button"
            className="p-6 bg-[var(--info-soft)] border-2 border-[var(--info-border)] rounded-xl hover:border-[var(--info)] hover:bg-[var(--primary-soft)] transition-all group"
            onClick={() => onSelectDocType('contratto')}
          >
            <div className="flex flex-col items-center gap-3">
              <div className="w-16 h-16 bg-[var(--primary-soft)] rounded-full flex items-center justify-center group-hover:bg-[var(--primary-soft)] transition-colors">
                <FileSignature size={32} className="text-[var(--primary)]" />
              </div>
              <div className="text-center">
                <p className="font-bold text-lg text-[var(--color-text)]">Contratto</p>
                <p className="text-sm text-[var(--color-text-muted)] mt-1">Genera un contratto commerciale</p>
              </div>
            </div>
          </button>

          <button
            type="button"
            className="p-6 bg-[var(--chart-accent-1-soft)] border-2 border-[var(--chart-accent-1)] rounded-xl hover:border-[var(--chart-accent-1)] hover:bg-[var(--primary-soft)] transition-all group"
            onClick={() => onSelectDocType('mandato')}
          >
            <div className="flex flex-col items-center gap-3">
              <div className="w-16 h-16 bg-[var(--chart-accent-1-soft)] rounded-full flex items-center justify-center group-hover:bg-[var(--chart-accent-1-soft)] transition-colors">
                <ScrollText size={32} className="text-[var(--chart-accent-1)]" />
              </div>
              <div className="text-center">
                <p className="font-bold text-lg text-[var(--color-text)]">Mandato di Assistenza</p>
                <p className="text-sm text-[var(--color-text-muted)] mt-1">Genera un mandato di assistenza</p>
              </div>
            </div>
          </button>
        </div>
      ) : selectedDocType === 'contratto' ? (
        <form
          id="create-contract-form"
          onSubmit={(event) => {
            event.preventDefault();
            contractForm.onSubmit();
          }}
        >
          <button
            type="button"
            data-create-form-secondary="true"
            className="mb-4 inline-flex items-center gap-2 text-sm text-[var(--color-text-muted)]"
            onClick={onBack}
          >
            <ArrowLeft size={16} aria-hidden="true" /> Cambia tipo documento
          </button>
          <CreateContractForm
            clients={clients}
            clientsUnavailable={clientsUnavailable}
            enableCustomFields
            renderActions={false}
            {...contractForm}
          />
        </form>
      ) : (
        <form
          id="create-mandate-form"
          onSubmit={(event) => {
            event.preventDefault();
            mandateForm.onSubmit();
          }}
        >
          <button
            type="button"
            data-create-form-secondary="true"
            className="mb-4 inline-flex items-center gap-2 text-sm text-[var(--color-text-muted)]"
            onClick={onBack}
          >
            <ArrowLeft size={16} aria-hidden="true" /> Cambia tipo documento
          </button>
          <CreateMandateForm
            clients={clients}
            clientsUnavailable={clientsUnavailable}
            enableCustomFields
            renderActions={false}
            {...mandateForm}
          />
        </form>
      )}
    </CreateFormDialog>
  );
}
